export default __webpack_public_path__ + "static/Rodrigo-Russell-b84219ea3715ae4a175126c1e495a0a6.png";